import { render, staticRenderFns } from "./languageBarChart.vue?vue&type=template&id=3c8230e6&scoped=true"
import script from "./languageBarChart.vue?vue&type=script&lang=js"
export * from "./languageBarChart.vue?vue&type=script&lang=js"
import style0 from "./languageBarChart.vue?vue&type=style&index=0&id=3c8230e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8230e6",
  null
  
)

export default component.exports